import ExportedImage from 'next-image-export-optimizer';
import { PageUrl } from '../../../constants/PageUrl';
import styles from './index.module.scss';

const handleClick = () => {
  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push({ event: 'line_cta_click', cta_position: 'blog_banner' });
};

export const LineBanner = () => (
  <a
    href={PageUrl.LINE_ACCOUNT}
    className={styles.base}
    target="_blank"
    rel="noopener noreferrer"
    onClick={handleClick}
  >
    <div className={styles['sp-only']}>
      <ExportedImage
        src="/img/line-creative-banner-mobile.webp"
        alt="LINE公式アカウント 友だち追加 - 困りごとが楽になるヒント無料プレゼント"
        width={600}
        height={300}
      />
    </div>
    <div className={styles['pc-only']}>
      <ExportedImage
        src="/img/line-creative-banner-pc.webp"
        alt="LINE公式アカウント 友だち追加 - 困りごとが楽になるヒント無料プレゼント"
        width={600}
        height={300}
      />
    </div>
  </a>
);
